// extracted by mini-css-extract-plugin
module.exports = {"wrapperDark":"_3pxo-GsGnEGY7KiG2WYOr-","rightEl":"_1yZtTgXoj8MNQussBtpxUl"};